// What the two OpCo roles mean, in one place: the Users Guide reads from here.
// The role follows the org Admin job role (the key stays 'manager'), so there is no
// separate role to pick. Each line matches the server rules in opco_api.py and
// CLAUDE.md section 9.
export const OPCO_ROLE_HELP = {
  member: {
    label: 'Member',
    summary: 'Works inside this OpCo and sees only its data.',
    can: [
      'Sees this OpCo’s templates, requests and documents',
      'Does what their organisation role allows (for example Reviewer or Approver) inside this OpCo only',
    ],
  },
  manager: {
    label: 'Admin',
    summary: 'The Admin of this OpCo: looks after its people and settings.',
    can: [
      'Invites, removes and deactivates people, and makes other users Admins',
      'Sets template access, NetSuite setup and the org-wide settings pages',
      'Sees this OpCo’s billing split',
      'Gets an alert when one of this OpCo’s requests fails extraction',
    ],
    cannot: [
      'Belong to more than one OpCo, create OpCos, or move requests and templates between OpCos (Super Admins only)',
      'Set up the OpCo’s Business Central or NetSuite connection (Super Admins only)',
    ],
  },
}

export function roleHelpText(role) {
  const h = OPCO_ROLE_HELP[role] || OPCO_ROLE_HELP.member
  return `${h.label}: ${h.summary}`
}

export default function OpCoRoleHelp({ role, className = '' }) {
  const h = OPCO_ROLE_HELP[role] || OPCO_ROLE_HELP.member
  return (
    <div
      className={`rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-800/30 px-3 py-2 text-xs text-gray-600 dark:text-gray-400 ${className}`}
      data-testid={`opco-role-help-${role}`}
    >
      <p className="font-semibold text-gray-900 dark:text-gray-100">{h.label}: {h.summary}</p>
      <ul className="mt-1 list-disc space-y-0.5 pl-4">
        {h.can.map((c) => <li key={c}>{c}</li>)}
      </ul>
      {h.cannot && (
        <>
          <p className="mt-2 font-medium">Cannot:</p>
          <ul className="mt-0.5 list-disc space-y-0.5 pl-4">
            {h.cannot.map((c) => <li key={c}>{c}</li>)}
          </ul>
        </>
      )}
    </div>
  )
}
